module.exports = __webpack_public_path__ + "img/19.b07b4ab4.jpg";